import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Support } from '@app/models/support';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SupportService {
    private subject = new Subject<any>();

    constructor(
        private httpClient: HttpClient
    ) { }

    //recuperation des supports pour un utilisateur
    getSupportsById(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}supports/read`, object)
            .pipe(
                map(res => res ? res.document.records as Support[] : []),
                catchError(this.handleError)
            );
    }

    // tous les supports
    getSupportsToManage() {
        return this.httpClient.get<any>(`${environment.apiEndPoint}supports/read_manage`)
            .pipe(
                map(res => res ? res.document.records as Support[] : []),
                catchError(this.handleError)
            );
    }

    //recuperation des supports non lus pour un utilisateur
    getUnreadSupportsByDestinataire(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}supports/unread`, object)
            .pipe(
                map(res => res ? res.document as any[] : []),
                catchError(this.handleError)
            );
    }
    
    //envoi de support
    createSupport(object) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}support/create`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    //mettre les supports à lus pour un utilisateur donné
    updateSupportsStatusByUser(object){
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}support/update`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    //mettre les supports à lus pour une demande donnée
    updateSupportsStatusByRequest(object){
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}support/update`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    clearSupports() {
        this.subject.next(null);
    }

    getSupport(): Observable<any> {
        return this.subject.asObservable();
    }

    private handleError(error: any): Promise<any> {
        let retour = error?.error?.message || error?.message || error;
        if(error?.error?.data) retour += '<br />'+error?.error?.data;
        return Promise.reject(retour);
    }
}